export default {seo:{title:'Parrainage',description:null},title:'Parrainage'};